namespace Areas.AsOfDate {
    "use strict;"

    let headerAsOfDateUpdated: boolean = false;

    export function contentReady(e: any) {
        headerAsOfDateUpdated = false;
    }

    export function rowPrepared(e: any) {
        if (!headerAsOfDateUpdated) {
            if (e.rowType == 'data' && $("#AsOfDate").length && e.data.hasOwnProperty('createdDateTime')) {
                $("#AsOfDate").text(Areas.formatDateTime(new Date(e.data.createdDateTime)));
                headerAsOfDateUpdated = true;
            }
        }
    }     
}